<form [formGroup]="form">
    <mat-form-field *ngIf="!readonly" class="procedureSelection">
        <input type="text" #procedureSel matInput placeholder="Práctica" formControlName="Procedure" [matAutocomplete]="procedureSelection" (input)="changeText()" />
        <mat-autocomplete [displayWith]="displayPosiblePracticesFn" #procedureSelection="matAutocomplete">
            <mat-option *ngFor="let procedure of filterCompletePosiblePractices | async" [value]="procedure">
                {{ procedure.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-spinner [diameter]="50" *ngIf="loadingValorization"></mat-spinner>
    <div *ngIf="!loadingValorization && items.length > 0; s">
        <table mat-table [dataSource]="items">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th class="val-cell" mat-header-cell *matHeaderCellDef>Nombre</th>
                <td class="val-cell" mat-cell *matCellDef="let element">
                    {{ fromIA(element) ? '(IA)-' : '' }} {{ getName(element) }} {{ getQuantity(element) }}
                </td>
                <td class="val-cell" mat-footer-cell *matFooterCellDef>
                    <b>Total </b>
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="authorization">
                <th class="val-cell" mat-header-cell *matHeaderCellDef></th>
                <td class="val-cell" mat-cell *matCellDef="let element">
                    {{ getAuthorization(element) }}
                </td>
                <td class="val-cell" mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="amount">
                <th class="val-cell" mat-header-cell *matHeaderCellDef>
                    Total paciente
                </th>
                <td class="val-cell" mat-cell *matCellDef="let element">
                    ${{ getPatientAmount(element) }}
                </td>
                <td class="val-cell" mat-footer-cell *matFooterCellDef>
                    <b> ${{ getTotal() }} </b>
                </td>
            </ng-container>

            <ng-container matColumnDef="star">
                <th class="val-cell" mat-header-cell class="search-table-header" *matHeaderCellDef></th>
                <td class="val-cell" mat-cell class="search-table-cell" *matCellDef="let element">
                    <button *ngIf="canEdit(element)" (click)="edit(element)" type="button" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>

                    <button *ngIf="canRemove(element)" (click)="remove(element)" type="button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>

                    <button *ngIf="canReverseRemove(element)" (click)="reverseRemove(element)" type="button" mat-icon-button>
          <mat-icon>replay</mat-icon>
        </button>


                    <mat-icon *ngIf="needExclude(element) || isExcluded(element) || transactionApplied(element)" [ngClass]="{ 'icon-red': transactionApplied(element) }">
                        close
                    </mat-icon>


                </td>
                <td class="val-cell" mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr class="val-cell" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr class="val-cell" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="val-cell" mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
    </div>
</form>